/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Statsaccountstotal2Inputs */

const en_statsaccountstotal2 = /** @type {(inputs: Statsaccountstotal2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} accounts in total`)
};

const de_statsaccountstotal2 = /** @type {(inputs: Statsaccountstotal2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Konten insgesamt`)
};

/**
* | output |
* | --- |
* | "{count} accounts in total" |
*
* @param {Statsaccountstotal2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsaccountstotal2 = /** @type {((inputs: Statsaccountstotal2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsaccountstotal2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsaccountstotal2(inputs)
	return de_statsaccountstotal2(inputs)
});
export { statsaccountstotal2 as "statsAccountsTotal" }